<template>
  <v-row>
    <v-flex shrink>
      <template>
        <div class="selectall ml-4">
          <v-checkbox
            v-model="selectAll"
            :disabled="itemsCount <= 0"
            hide-details
            :label="`Select All`"
            @change="doSelectAll"
          ></v-checkbox>
        </div>
      </template>
    </v-flex>
    <v-flex shrink>
      <v-progress-circular
        v-if="loading == true"
        class="ml-2"
        :size="15"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-flex>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import {
  SELECT_ALL_PHOTO_ADD,
  SELECT_ALL_PHOTO_REMOVE,
} from "@/store/actions.type";
import toast from "@/services/toast";

export default {
  name: "SelectAll",
  data: () => ({
    selectAll: false,
    loading: false,
  }),
  computed: {
    totalResults() {
      return this.imageSearchResult.total;
    },
    itemsCount() {
      return this.imageSearchResult.data.length;
    },
    ...mapGetters([
      "imageSearchResult",
      "currentUser",
      "collection",
      "activeExpClient",
    ]),
    ...mapState(["selectAllLimit"]),
  },
  watch: {
    totalResults(val) {
      if (val <= 0 || typeof val === "undefined") this.selectAll = false;
    },
  },
  methods: {
    doSelectAll() {
      this.loading = true;
      const action = this.selectAll
        ? SELECT_ALL_PHOTO_ADD
        : SELECT_ALL_PHOTO_REMOVE;
      this.$store
        .dispatch(action, {
          clientId: this.activeExpClient.id,
          collectionId: this.collection.id,
        })
        .then(() => {
          this.loading = false;
          if (this.totalResults > this.selectAllLimit) {
            toast.info(
              `This will select the first ${this.selectAllLimit} photos`
            );
          }
        });
    },
  },
};
</script>
